// deepanshu_code

import MatchOddsCricket from "./userSetting/MatchOddsCricket";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import MatchOddsFootball from "./userSetting/MatchOddsFootball";
import BookMakerCricket from "./userSetting/BookMakerCricket";
import FancyCricket from "./userSetting/FancyCricket";
import ToWinTheTossCricket from "./userSetting/ToWinTheTossCricket";
import TiedMatchCricket from "./userSetting/TiedMatchCricket";
import ComplitedMatchCricket from "./userSetting/ComplitedMatchCricket";
import TournamentWinnerCricket from "./userSetting/TournamentWinnerCricket";
import LineMarketCricket from "./userSetting/LineMarketCricket";
import SuperOverCricket from "./userSetting/SuperOverCricket";
import DrawNoBet from "./userSetting/DrawNoBet";
import GoalMarketFootball from "./userSetting/GoalMarketFootball";
import BookMakerFootball from "./userSetting/BookMakerFootball";
import MatchOddsTennis from "./userSetting/MatchOddsTennis";
import BookMakerTennis from "./userSetting/BookMakerTennis";
import MiniBookMakerCricket from "./userSetting/MiniBookMakerCricket";
import api from "../../../utils/api";
export const base_url = process.env.REACT_APP_API_URL;

const UserSetting = () => {
  const { user_phone, user_code } = useParams();
 const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  

  const fetchUserData = useCallback(async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await api.post(
        "/api/webapi/admin/listMember",
        
      );
      // console.log('resp',response);

      if (!response.data.status) throw new Error("Failed to fetch users");
      const data = response.data;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, []);

  
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <>
      <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
          <div className="side-body padding-top">
            <nav className="indigo userSetting1" role="navigation">
              <div className="nav-wrapper">
                <a
                  href="##"
                  className="brand-logo "
                >
                  User Phone [{user_phone}]
                </a>
                <a href="##" data-activates="slide-out" className="button-collapse">
                  <i className="mdi-navigation-menu" />
                </a>
              </div>
            </nav>
            <div className="marquee1">
              <span className="general_message" id="general_message">
                We have launched 4500+ games in new I-casino please note in new i-casino
                1point = 100 points
              </span>
            </div>


            <div className="card">
              <div className="card-content userSetting">

                <MatchOddsCricket user_phone={user_phone} user_code={user_code}/>
                <MatchOddsFootball user_phone={user_phone} user_code={user_code}/>
                <BookMakerCricket user_phone={user_phone} user_code={user_code}/>
                <MiniBookMakerCricket user_phone={user_phone} user_code={user_code}/>
                <FancyCricket user_phone={user_phone} user_code={user_code}/>
                <ToWinTheTossCricket user_phone={user_phone} user_code={user_code}/>
                <TiedMatchCricket user_phone={user_phone} user_code={user_code}/>
                <ComplitedMatchCricket user_phone={user_phone} user_code={user_code}/>
                <TournamentWinnerCricket user_phone={user_phone} user_code={user_code}/>
                <LineMarketCricket user_phone={user_phone} user_code={user_code}/>
                <SuperOverCricket user_phone={user_phone} user_code={user_code}/>
                <DrawNoBet user_phone={user_phone} user_code={user_code}/>
                <GoalMarketFootball user_phone={user_phone} user_code={user_code}/>
                <BookMakerFootball user_phone={user_phone} user_code={user_code}/>
                <MatchOddsTennis user_phone={user_phone} user_code={user_code}/>
                <BookMakerTennis user_phone={user_phone} user_code={user_code}/>

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};
export default UserSetting;
